
import axios from 'axios';

// Создаем настроенный экземпляр axios
const apiClient = axios.create({
    baseURL: process.env.NODE_ENV === 'production' 
      ? process.env.REACT_APP_API_URL 
      : "", // Пустая строка для использования прокси в разработке
    // headers: {
    //   'Content-Type': 'application/json',
    // },
});
  
// Перехватчик для добавления токена аутентификации
apiClient.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
 );
  
// Перехватчик для обработки ответов
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Удаляем токен и перенаправляем на страницу входа
            localStorage.removeItem('token');
            window.location.href = '/performance-admin-panel/login';
        }
        return Promise.reject(error);
    }
);

// Универсальная функция для запросов
const request = async (url, method = 'GET', data = null, defaultErrorMessage = 'Произошла ошибка при выполнении запроса', isFormData = false) => {
    try {
        const config = { 
            method, 
            url,
            headers: {}
        };

        // Если данные это FormData, не устанавливаем Content-Type, axios сделает это автоматически
        // В противном случае используем application/json
        if (!isFormData) {
            config.headers['Content-Type'] = 'application/json';
        }
        
        if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
            config.data = data;
        }
        
        // await new Promise(resolve => setTimeout(resolve, 3000)); // Для отладки
        const response = await apiClient(config);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        if (error.response) {
            // Форматирование сообщения об ошибке в зависимости от структуры ответа сервера
            let errorMessage = defaultErrorMessage;
            
            if (error.response.status === 500) {
                errorMessage = 'Ошибка на сервере. Попробуйте снова позже';
            }
            else {
                if (error.response.data) {
                    if (typeof error.response.data === 'string') {
                        // Если ответ - простая строка
                        errorMessage = error.response.data;
                    } else if (error.response.data.message) {
                        // Если есть поле message
                        errorMessage = error.response.data.message;
                    } else if (error.response.data.error) {
                        // Если есть поле error
                        errorMessage = error.response.data.error;
                    } else if (error.response.data.errors) {
                        // Если есть объект errors (может быть массивом или объектом со свойствами)
                        if (Array.isArray(error.response.data.errors)) {
                            // Если это массив
                            errorMessage = error.response.data.errors.join('. ');
                        } else {
                            // Если это объект со свойствами (формат ModelState из ASP.NET)
                            const errorMessages = [];
                            
                            // Перебираем все поля с ошибками
                            Object.keys(error.response.data.errors).forEach(fieldName => {
                                const fieldErrors = error.response.data.errors[fieldName];
                                if (Array.isArray(fieldErrors)) {
                                    // Добавляем все сообщения об ошибках данного поля
                                    errorMessages.push(...fieldErrors);
                                }
                            });
                            
                            if (errorMessages.length > 0) {
                                errorMessage = errorMessages.join('. ');
                            }
                        }
                    }
                }
            } 
            
            return {
                success: false,
                error: errorMessage,
                // errorDetails: error.response.data, // Сохраняем все данные об ошибке
                statusCode: error.response.status
            };
        } else if (error.request) {
            return {
                success: false,
                error: 'Нет ответа от сервера. Проверьте интернет-соединение'
            };
        } else {
            return {
                success: false,
                error: defaultErrorMessage
            };
        }
    }
};

export default {
    get: (url, errorMessage) => request(url, 'GET', null, errorMessage),
    post: (url, data, errorMessage, isFormData = false) => request(url, 'POST', data, errorMessage, isFormData),
    put: (url, data, errorMessage, isFormData = false) => request(url, 'PUT', data, errorMessage, isFormData),
    delete: (url, errorMessage) => request(url, 'DELETE', null, errorMessage),
    patch: (url, data, errorMessage, isFormData = false) => request(url, 'PATCH', data, errorMessage, isFormData)
};